import styled from 'styled-components';

const DisableCover = styled.div`
  position: absolute;
  cursor: default;
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${props => props.transparent ? 'transparent' : 'rgba(255, 255, 255, 0.5)'};
`;

export default DisableCover;



// WEBPACK FOOTER //
// ./src/components/libs/disabled/index.js